// Format date as "Lundi 14/09/2026" — parses YYYY-MM-DD as a local calendar date (no UTC shift)
export const parseLocalDate = (dateStr) => {
  if (dateStr instanceof Date) return dateStr;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr || '');
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(dateStr);
};

// Today's business date in Europe/Zurich as YYYY-MM-DD
export const todayZurich = () => {
  const parts = new Intl.DateTimeFormat('fr-CA', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const get = (t) => parts.find(p => p.type === t)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
};

export const NO_DATE = 'Date non renseignée';
const isValid = (d) => d instanceof Date && !Number.isNaN(d.getTime());

export const formatDateFR = (dateStr) => {
  if (!dateStr) return NO_DATE;
  const d = parseLocalDate(dateStr);
  if (!isValid(d)) return NO_DATE;
  const day = d.toLocaleDateString('fr-FR', { weekday: 'long' });
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${day.charAt(0).toUpperCase() + day.slice(1)} ${dd}/${mm}/${yyyy}`;
};

// Long format: "lundi 14 septembre 2026"
export const formatDateLongFR = (dateStr) => {
  if (!dateStr) return NO_DATE;
  const d = parseLocalDate(dateStr);
  if (!isValid(d)) return NO_DATE;
  return d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
};

// Short format: "Lun. 14/09"
export const formatDateShortFR = (dateStr) => {
  if (!dateStr) return NO_DATE;
  const d = parseLocalDate(dateStr);
  if (!isValid(d)) return NO_DATE;
  const day = d.toLocaleDateString('fr-FR', { weekday: 'short' });
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${day} ${dd}/${mm}`;
};

// "14/09 10:30" or "Date non renseignée"
export const formatDateTimeFR = (iso) => {
  if (!iso) return NO_DATE;
  const d = new Date(iso);
  if (!isValid(d)) return NO_DATE;
  return d.toLocaleString('fr-FR', { timeZone: 'Europe/Zurich', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

// Échappement HTML pour tout contenu injecté dans une page d'impression (anti-XSS stocké)
export const escapeHtml = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
